export default __webpack_public_path__ + "static/684-e4f5231f4191c6615cea4f6894e48a19.gif";